<template>
  <div id="breadCrumb">
    <p class="pageTxt">{{ title }}</p>
    <ul class="menu-flow">
      <li class="home">
        <img
          :src="require('@/assets/images/ico/ico-home.svg')"
          alt="홈 아이콘"
        />
      </li>
      <li v-for="(title, index) in menuTitleList" :key="index">{{ title }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    menuTitleList() {
      return this.$route.meta.category;
    },

    title() {
      return this.$route.meta.category[this.menuTitleList.length - 1];
    },
  },
};
</script>
